import {Button} from "@mui/material";
import type {SxProps, Theme} from "@mui/material/styles";
import {type ReactNode} from "react";
import {useTranslation} from "react-i18next";

export interface ControlButtonProps {
    onClick: () => void;
    disabled?: boolean;
    icon?: ReactNode;
    textKey?: string;
    /** Interpolation values for textKey, e.g. a countdown. */
    textValues?: Record<string, string | number>;
    className?: string;
    sx?: SxProps<Theme>;
    /** Sized to sit next to a small input instead of standing in the control bar. */
    compact?: boolean;
}

const ControlButton = (props: ControlButtonProps) => {
    const {t} = useTranslation();

    const handleOnClick = () => {
        props.onClick();
    };

    const opacity = props.disabled ? 0.5 : 1;
    const cursor = props.disabled ? "not-allowed" : "pointer";

    const sxOverrides = props.sx;
    const defaultSx = props.compact
        ? {
            "&.MuiButtonBase-root.MuiButton-root": {
                minWidth: "auto",
                minHeight: "40px",
                height: "40px",
                fontSize: "14px",
                paddingLeft: "14px",
                paddingRight: "14px",
            },
            whiteSpace: "nowrap",
            cursor,
            opacity,
        }
        : {
            "&.MuiButton-root": {
                minWidth: "200px",
                minHeight: "48px",
                height: "48px",
            },
            fontSize: "16px",
            whiteSpace: "nowrap",
            cursor,
            opacity,
        };

    return (
        <Button
            className={`text-center font-lato font-bold ${props.className}`}
            onClick={handleOnClick}
            disabled={props.disabled}
            variant="contained"
            endIcon={props.icon}
            sx={[
                defaultSx,
                ...(Array.isArray(sxOverrides) ? sxOverrides : sxOverrides ? [sxOverrides] : []),
            ]}
        >
            {t(props.textKey, props.textValues)}
        </Button>
    );
};

export default ControlButton;
